





































































































import { Component } from 'vue-property-decorator';
import {Getter} from "vuex-class";
import AccountsFilter from "@/components/Settings/Accounts/AccountsFilter.vue";
import {ScrollButton} from "wings-ui-components";
import {AccountItem} from "@/store/settings/accounts/types";
import BaseItemsPage from '../BaseItemsPage';
import TemplatesFilter from "@/components/Templates/TemplatesFilter.vue";

@Component({components: {TemplatesFilter, AccountsFilter,ScrollButton}})
export default class Accounts extends BaseItemsPage<AccountItem> {
  @Getter("accounts") accountsResponse: any;

  is_show_filter = false;
  currentSort= "id";
  currentSortOrder= "desc";

  tableFields = [
    'name',
    'login',
    'protocol',
    'partner',
    'transport',
    'status',
  ];

  getData(): any {
    return this.accountsResponse ? this.accountsResponse : [];
  }

  getJoinedArray(item: string[] | undefined | null): string | undefined | null {
    return item?.join(', ');
  }
}
